import { render, staticRenderFns } from "./business-item.vue?vue&type=template&id=6d29d4b3&scoped=true&"
import script from "./business-item.vue?vue&type=script&lang=js&"
export * from "./business-item.vue?vue&type=script&lang=js&"
import style0 from "./business-item.vue?vue&type=style&index=0&id=6d29d4b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d29d4b3",
  null
  
)

export default component.exports